import { PaletteMode } from '@mui/material';
import { ChronosphereColorPalette, blue } from '../colors';
import { GetThemeOptions } from '../../theme';
import { unityDarkTokens, unityLightTokens } from '@/theme/unityTokens';

export const infoColor = (mode: PaletteMode, opts: GetThemeOptions): ChronosphereColorPalette => {
  if (opts.panwRebrandStubYear) {
    return mode === 'light'
      ? {
          main: unityLightTokens['--data-informative-informative'],
          highContrast: unityLightTokens['--data-informative-informative-high-contrast'],
          lowContrast: unityLightTokens['--data-informative-informative-low-contrast'],
        }
      : {
          main: unityDarkTokens['--data-informative-informative'],
          highContrast: unityDarkTokens['--data-informative-informative-high-contrast'],
          lowContrast: unityDarkTokens['--data-informative-informative-low-contrast'],
        };
  }

  return mode === 'light'
    ? {
        main: blue[500],
        highContrast: blue[700],
        lowContrast: blue[100],
      }
    : {
        main: blue[400],
        highContrast: blue[100],
        lowContrast: blue[800],
      };
};
